module.exports = __webpack_public_path__ + "img/00_bg_01.653442a0.png";